import { render, staticRenderFns } from "./PersistentVolumeClaim.vue?vue&type=template&id=42b5c71a&"
import script from "./PersistentVolumeClaim.vue?vue&type=script&lang=js&"
export * from "./PersistentVolumeClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports